module.exports = __webpack_public_path__ + "static/media/background.32162f64.png";